import * as React from 'react';

import { TAvailability } from 'ui-model';

import { useSettingSchedulerDates } from 'hooks';

import { useLumaBotContext } from '../../../../LumaBot.context';

import QueryListAvailabilitiesGrouped from './components/QueryListAvailabilitiesGrouped';

type Props = {
  filtersParams?: {
    appointmentType: string | string[];
    facility?: string | string[];
    includeNullApptTypes?: boolean;
    provider?: string | string[];
  };
  onChange: (value: TAvailability) => void;
};

const ExtendedSchedulerAvailabilitiesList = (props: Props) => {
  const { filtersParams, onChange } = props;
  const [{ startDate, endDate }, setDateRange] = React.useState(useSettingSchedulerDates());

  const { currentFlowId, currentFlowTemplateId } = useLumaBotContext();

  return (
    <QueryListAvailabilitiesGrouped
      params={{
        ...filtersParams,
        date: !!startDate && !!endDate ? [`>${startDate?.format()}`, `<${endDate?.format()}`] : undefined,
        lumabotFlow: currentFlowId,
        lumabotFlowTemplate: currentFlowTemplateId,
      }}
      dateRange={{ startDate, endDate }}
      setDateRange={setDateRange}
      onChange={onChange}
      isMobile
    />
  );
};

export default ExtendedSchedulerAvailabilitiesList;
